module.exports = __webpack_public_path__ + "img/visa_white.44350dff.png";